<template>
  <div class="corner">
    <Icon type="edit" size="10"></Icon>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.corner {
  @width: 36px;
  width: @width;
  height: @width;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  text-align: center;
  border-top: @width/2 solid #5cadff;
  border-right: @width/2 solid #5cadff;
  border-bottom: @width/2 solid  rgba(0,0,0,0);
  border-left: @width/2 solid  rgba(0,0,0,0);
  /deep/.ivu-icon {
    color: #fff;
    position: absolute;
    right: -@width/3;
    top: -@width/3;
  }
}
</style>
